import I18nForLwText from './LwText'

export default class I18nForLwCheckbox extends I18nForLwText {
  name = 'lw-checkbox'
}
